// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../var/task/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".asd__wrapper[data-v-44b5c48a]{min-height:335px}", ""]);
// Exports
module.exports = exports;
